<template>
  <div ref="countersSection" class="counters-section" role="region" aria-labelledby="counters-title">
    <b-container fluid class="text-white py-4">
      <h3 id="counters-title" class="sr-only">إحصائيات منصة البارون</h3> <!-- عشان برامج قراءة الشاشة -->

      <b-row class="text-center">
        <b-col cols="12" md="4">
          <div class="column" role="group" aria-label="عدد الطلاب">
            <h4 class="mt-2">+ {{ animatedStudentCounter }} <br> طالب وطالبة</h4>
            <i class="fa fa-graduation-cap text-warning fa-5x mx-3" aria-hidden="true"></i>
          </div>
        </b-col>

        <b-col cols="12" md="4">
          <div class="column" role="group" aria-label="عدد المعلمين">
            <h4 class="mt-2">+ {{ animatedTeacherCounter }} <br>معلم ومعلمة</h4>
            <i class="fa fa-users text-warning fa-5x mx-3" aria-hidden="true"></i>
          </div>
        </b-col>

        <b-col cols="12" md="4">
          <div class="column" role="group" aria-label="شركاء النجاح">
            <h4 class="mt-2">+ {{ animatedPartnerCounter }} <br>شركاء نجاح</h4>
            <i class="fa fa-building text-warning fa-5x mx-3" aria-hidden="true"></i>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { sendRequest } from '../../utils/RequestHelper';

export default {
  name: 'HowToJoin',
  data() {
    return {
      data: {},
      animatedStudentCounter: 0,
      animatedTeacherCounter: 0,
      animatedPartnerCounter: 0,
      hasStartedCounting: false
    };
  },
  methods: {
    loadData() {
      this.pageIsLoading = true;
      sendRequest('get', 'configuration/configuration/', false, {}, (data) => {
        this.data = data || {};
        this.pageIsLoading = false;
        this.observeSection(); // تشغيل المراقبة بعد تحميل البيانات
      }, () => {
        this.pageIsLoading = false;
      });
    },
    
    startCounting(target, prop) {
      let count = 0;
      let step = Math.ceil(target / 50); // تقسيم الرقم إلى 50 خطوة تقريبًا
      let interval = setInterval(() => {
        count += step;
        if (count >= target) {
          count = target;
          clearInterval(interval);
        }
        this[prop] = count;
      }, 30); // سرعة العد
    },

    observeSection() {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.hasStartedCounting) {
          this.hasStartedCounting = true;
          this.startCounting(this.data.student_counter, 'animatedStudentCounter');
          this.startCounting(this.data.teacher_counter, 'animatedTeacherCounter');
          this.startCounting(this.data.partner_counter, 'animatedPartnerCounter');
        }
      }, { threshold: 0.25 });

      observer.observe(this.$refs.countersSection);
    }
  },
  created() {
    this.loadData();
  }
};
</script>

<style scoped>
.counters-section {
  padding: 10px 85px !important;
  background-color: var(--brand-teal-dark) !important;
}

.counters-section .text-warning {
  color: #f1c40f !important;
}

.counters-section h4 {
  font-weight: bold;
  font-size: 30px;
}

.counters-section .column {
  display: flex !important;
  justify-content: center;
  align-items: center;
  margin: 50px 0; 
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* tablet */
@media (max-width: 991.98px) {
  .counters-section {
    padding: 20px 30px 40px !important;
  }
}

/* tablet: three counters share one row, so shrink them */
@media (max-width: 991.98px) {
  .counters-section h4 {
    font-size: 22px;
  }

  .counters-section .fa-5x {
    font-size: 3em;
  }

  .counters-section .column {
    margin: 24px 0;
  }
}

/* mobile */
@media (max-width: 767.98px) {
  .counters-section {
    padding: 10px 15px 30px !important;
  }

  .counters-section .column {
    margin: 16px 0;
  }
}
</style>
